module.exports = __webpack_public_path__ + "img/press1.b2cb8907.png";